import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';

const loginbox = GLightbox({
  'selector': '.loginbox'
});

const activebox = GLightbox({
  'selector': '.activebox',
  closeButton: false,
  closeOnOutsideClick: false,
  draggable: false,
  height: '90vh'
});

function subscribe(post_id,post_type) {
  $.ajax({
    type: "POST",
    dataType: "json",
    url: lm_ajax_script.ajaxurl,
    data: '&action=subscribe&post_id='+post_id+'&post_type='+post_type,
    success: function (data) {
      if(data) {
        sessionStorage.removeItem(post_type);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        	'event' : 'follow',
          'user' : data.user_id
        });
        $('.abo[data-id="'+post_id+'"]').addClass('subscribed');
        if(window.welcome) {
          $('.card-'+post_id).addClass('liked');
          window.likedProjects++;
          if(post_type == 'projekt' && (window.likedProjects >= 3)) {
            $('.welcome-tab-1 .welcome--next').removeClass('disabled');
            $('.welcome-tab-1 .welcome--next--text').hide();
          }
        }
        else if(post_type == 'netzwerk'){
          sessionStorage.removeItem('network');
          window.location.reload();
        }
        /*else {
          window.location.reload();
        }*/
      }
    },
    error: function (request, status, error) {
      console.log(request.responseText);
    }
  });
}

function own(project) {
  $.ajax({
    type: "POST",
    dataType: "json",
    url: lm_ajax_script.ajaxurl,
    data: '&action=own&project='+project,
    success: function(data) {
      if(data) {
        sessionStorage.removeItem('project-admin');
        window.location.reload();
      }
    },
    error: function (request, status, error) {
      console.log(request.responseText);
    }
  });
}

$(document).ready(function() {
  if($('#activePop').length) {
    activebox.open();
  }
  /*var mediaframe = wp.media();
  if(mediaframe) {
    frame.on('open',function() {
      wp.media.frame.content.mode('browse');
    });
  }*/
  /*setTimeout(function() {
    wp.media.frame.on('open',function() {
      wp.media.frame.content.mode('browse');
    });
  },1000);*/
  if(document.body.classList.contains('logged-in')) {
    var project = sessionStorage.getItem('project');
    if(project) subscribe(project,'projekt');

    var project_admin = sessionStorage.getItem('project-admin');
    if(project_admin) own(project_admin);

    var network = sessionStorage.getItem('network');
    if(network) subscribe(network,'netzwerk');
  }
  var add_project = getUrlParameter('project');
  if(add_project) {
    sessionStorage.setItem('project',add_project);
    window.location = window.location.href.split("?")[0];
  }
  var own_project = getUrlParameter('project-admin');
  if(own_project) {
    sessionStorage.setItem('project-admin',own_project);
    window.location = window.location.href.split("?")[0];
  }
  var add_network = getUrlParameter('network');
  if(add_network) {
    sessionStorage.setItem('network',add_network);
    window.location = window.location.href.split("?")[0];
  }
  if(add_network || add_project) {
    // @TODO Add invite related message
    if(!document.body.classList.contains('logged-in')) {
      //document.location.href = '/login';
      loginbox.open();
    }
  }

  $('#btnLos').click(function(e) {
    activebox.close();
  });
  $('.welcome--next').click(function(e) {
    e.preventDefault();
    var tab = $(this).data('tab');
    if(tab && !$(this).hasClass('disabled')) {
      var next = parseInt(tab) + 1;
      if($('.welcome-tab-'+next).hasClass('empty')) {
        next++;
      }
      $('.welcome-tab-'+tab).addClass('hidden');
      $('.welcome-tab-'+next).removeClass('hidden');
    }
    return false;
  });
});

function handleLike(e) {
  var targetEl = getClosest (e.target, '.abo,.card.welcome');
  if(targetEl && document.body.classList.contains('logged-in')){
    if(!$(targetEl).hasClass('liked') && !$(targetEl).hasClass('subscribed')) {
      subscribe($(targetEl).data('id'),$(targetEl).data('type'));
    }
  }
  else {
    sessionStorage.setItem($(targetEl).data('type'), $(targetEl).data('id'));
    loginbox.open();
  }
}

function addCustomEventListener(selector, event, handler) {
  let rootElement = document.querySelector('body');
  rootElement.addEventListener(event, function (evt) {
          var targetElement = evt.target;
          while (targetElement != null) {
              if (targetElement.matches(selector)) {
                evt.preventDefault();
                handler(evt);
                return false;
              }
              targetElement = targetElement.parentElement;
          }
      },
      true
  );
}
addCustomEventListener('.abo,.card.welcome','click',handleLike);

$('body.logged-out .cld-like-trigger').click(function(e) {
  e.preventDefault();
  loginbox.open();
  return false;
});

$('.comment-reply-login,.must-log-in a').click(function(e) {
  e.preventDefault();
  loginbox.open();
  //document.location.href = '/login';
  return false;
});

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

// Element.matches() polyfill
if (!Element.prototype.matches) {
  Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function(s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(s),
              i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
      };
}

var getClosest = function (elem, selector) {
	for ( ; elem && elem !== document; elem = elem.parentNode ) {
		if ( elem.matches( selector ) ) return elem;
	}
	return null;
};